export default {
  routes: [
    {
      name: 'TheForm',
      path: '/form/:uuid',
      component: () => import('./views/TheFormModule.vue'),
    },
    {
      name: 'TheFormResult',
      path: '/form/:uuid/result',
      component: () => import('./views/TheFormModuleResult.vue')
    },
    {
      name: 'TheAllForms',
      path: '/forms',
      component: () => import('./views/TheForms.vue')
    }
  ]
}
